import React, { Fragment, useEffect, useMemo, useState } from "react";
import moment from "moment";
import Note from "components/note/Note";
import { ButtonNew as Button } from "components/buttonNew/index";
import { IBooking, IBookingParticipant, ISlot } from "redux/reducers/models/teetime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-light-svg-icons";
import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";

import Sheet from "components/sheet/Sheet";
import Input from "components/form/input/Input";
import Popup from "components/popup/Popup";
import FormLayout from "components/form/FormLayout";
import Callout from "components/callout/Callout";
import Tabs from "components/tabs/Tabs";
import SelectNew from "components/select/SelectNew";
import BookingSourceLogo from "components/bookingSourceLogo/BookingSourceLogo";

import { IAPIResponse, StatusCode } from "api/protocols";
import { selectTeeTime } from "redux/actions/teesheet";
import { PutBookingParticipant, GetBookingNotes } from "api/rpc/2024-04/facilityAdmin/teesheet/booking";
import { showError, showSuccess } from "redux/actions/ui";

import { useTranslation } from "react-i18next";
import axios, { CancelToken } from "axios";
import { NavigationDropdownNew } from "components/navigationDropdownNew/NavigationDropdownNew";
import Portal from "elements/Portal";
import { Badge } from "components/badge/Badge";
import { capitalize, errorMessage, valueToString } from "helpers/Helpers";
import { isSlotEligibleForTicketFeeRedemption } from "helpers/ticketRedemption";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useRegisterContext } from "../../register/registerNew/RegisterContext";
import { IOrderProgess, OrderProgress } from "./NewTeeSheetDetails";
import { useHistory, useParams } from "react-router";

import { GetCustomerNotes, PutCustomer } from "api/rpc/2024-04/facilityAdmin/customer/customer";
import { GetCustomerMemberships } from "api/rpc/2024-04/facilityAdmin/customer/membership";
import { GetPowerCarts, IPowerCart } from "api/rpc/2024-04/facilityAdmin/facility/powercart/powercart";
import { TCustomerNote } from "../../customer/context/contextTypes";
import useModal from "hooks/modals/useModal";
import Checkbox from "components/form/checkbox/Checkbox";
import PowerCartNumbersModal, { MAX_SEATS_PER_CART } from "../newTeeSheet/modals/PowerCartNumbersModal";
import SimpleMembershipDisplay from "components/simpleMembershipDisplay/SimpleMembershipDisplay";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./newTeeSheetDetails.scss";
import {
  faArrowUTurnUpRight,
  faCartShopping,
  faCheck,
  faCheckCircle,
  faEllipsisVertical,
  faExclamationCircle,
  faFlag,
  faLocationCheck,
  faMessageCheck,
  faPersonGolfing,
  faPersonWalking,
  faUsdCircle,
} from "@fortawesome/pro-regular-svg-icons";
import TextField from "components/form/textField/TextField";
import Toggle from "components/form/toggle/Toggle";
import Drawer from "components/drawerSlide/drawer";
import ReviewPlayerDetailsModal from "./reviewPlayerDetailsModal/ReviewPlayerDetailsModal";
import { IStub } from "redux/reducers/models/ticket";
import { GetLiabilityWaivers } from "api/rpc/2024-04/facilityAdmin/facility/liabilityWaiver";
import { ILiabilityWaiver } from "pages/secure/facility/settings/liabilityWaivers/LiabilityWaivers";
interface ITeeSheetBookings {
  initiateEditBookingHandler: (booking: IBooking, newPlayerAdded?: boolean) => void;
  checkInHandler: (slot: ISlot) => void;
  noShowBookingHandler: (
    slot: ISlot,
    type: "charge" | "defer" | "weather",
    allSlotIds?: number[],
    sendNoShowChargeEmail?: boolean,
  ) => void;
  chargeNoShowHandler: (slot: ISlot) => void;
  showChangePlayerHandler: (bookingParticipant: IBookingParticipant) => void;
  cancelBookingParticipantHandler: (slot: ISlot) => void;
  loadCartWaiverHandler: (customer_id: number) => void;
  loadLiabilityWaiverHandler: (customer_id: number, waiver_id: number) => void;
  initiateRedeemTicketHandler: (slot: ISlot) => void;
  initiateAddFeeHandler: (
    event: React.MouseEvent<Element, MouseEvent>,
    slot: ISlot,
    product_type: "Green Fee" | "Power Cart",
    green_fee_added?: boolean,
    power_cart_fee_added?: boolean,
    orderStarted?: boolean,
  ) => void;
  order?: Record<string, any>;
  cart?: Record<string, any>;
  powerCartModalVisible: boolean;
  togglePowerCartModalVisible: (visible: boolean) => void;

  orderProgress: IOrderProgess;
  addFeeHandler: (
    slot: ISlot,
    greenFee: {
      id: number;
      productTitle: string;
      variantTitle: string;
    },
    powerCartFee: {
      id: number;
      productTitle: string;
      variantTitle: string;
    },
    event: React.MouseEvent<Element, MouseEvent>,
  ) => Promise<void>;
  removeFeeHandler: (
    slot: ISlot,
    variantId: number,
    type: "green_fee" | "power_cart_fee",
    event: React.MouseEvent<Element, MouseEvent>,
  ) => void;

  createPlayerNote: (payload: {
    customer_id: number;
    content: string;
    high_priority: boolean;
    tee_time_booking_id: number;
  }) => Promise<void>;

  reloadTeeTimes: () => void;

  initiateIssueRainCheckHandler: (slot: ISlot) => void;
  initiateRedeemRainCheckHandler: () => void;
  removeNoShowBookingHandler: (slot: ISlot) => void;

  promptCartNumberForSlot?: ISlot | null;
  clearPromptCartNumberForSlot?: () => void;

  reviewPlayersModalVisable: boolean;
  closeReviewPlayersModal: () => void;
}

interface IEditCustomerState {
  customerEditVisible: boolean;
  customerFirstName: string;
  customerEmail: string;
  customerPhone: string;
  customerLastName: string;
  customerId: number;
  teeTimeId: string;
  bookingId: number;
  booking_participant_id: number;
  customer_image: any;
  customerMemberships: any;
  customerType: string;
  cartCustomerType: string;
  customerMemberNumber: string;
}

interface IEditNameState {
  newName: string;
  selectedBookingParticipant: IBookingParticipant;
  modalOpen: boolean;
}

interface ICartNumbersState {
  cartNumbersModalVisible: boolean;
  cartNumberModalVisible: boolean;
  selectedPowerCarts: ISelectedPowerCarts[];
  seatNumbers: number[];
  currentSlot: ISlot;
  availablePowerCarts: IPowerCart[];
  loadedAvailableCarts: boolean;
}

interface ISelectedPowerCarts {
  power_cart_id: number;
  power_cart_number: number;
  participant_id: number;
  seat_number: number;
}

const NewTeeSheetBookingDisplay: React.FC<ITeeSheetBookings> = props => {
  const { teetimeId } = useParams<{ teetimeId: string }>();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { teeSheetStore, facilityStore, authStore } = useAppSelector(store => store);
  const history = useHistory();

  const { order, orderProgress, addFeeHandler, removeFeeHandler } = props;

  const permissions = authStore?.user?.permissions;

  const { participantPaidFees } = useRegisterContext();

  const [editCustomerState, setEditCustomerState] = useState<IEditCustomerState>({
    customerEditVisible: false,
    customerEmail: "",
    customerFirstName: "",
    customerLastName: "",
    customerPhone: "",
    customerId: null,
    teeTimeId: "",
    bookingId: null,
    booking_participant_id: null,
    customer_image: null,
    customerMemberships: null,
    customerType: "",
    cartCustomerType: "",
    customerMemberNumber: "",
  });

  const {
    state: noShowModal,
    updateModal: updateNoShowModal,
    closeModal: closeNoShowModal,
  } = useModal({
    type: null as "charge" | "defer" | "weather",
    slot: null as ISlot,
    markAllPlayers: false,
    allSlotIds: null as number[],
    sendNoShowChargeEmail: false,
  });

  const memoizedCustomers = useMemo(() => {
    return teeSheetStore?.selectedTeeTime?.slots
      ?.filter(slot => slot?.booking_participant?.customer_id && !slot?.booking_participant?.guest)
      ?.map(slot => slot?.booking_participant?.customer);
  }, [teeSheetStore?.selectedTeeTime]);

  useEffect(() => {
    const source = axios.CancelToken.source();

    if (noteState === null && editCustomerState.customerId) {
      void loadCustomerNotes(false, source.token);
    }

    return () => {
      source.cancel();
    };
  }, [editCustomerState.customerId]);

  const [noteState, setNoteState] = useState(null);

  const [notes, setNotes] = useState<Record<string, any>[]>([]);
  const [highPriorityNotes, setHighPriorityNotes] = useState<TCustomerNote[]>([]);
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const tabs = [
    {
      id: "Details",
      content: t("Details"),
    },
    {
      id: "Notes",
      content: "Notes",
    },
  ];

  const [editName, setEditName] = useState<IEditNameState>({
    newName: "",
    selectedBookingParticipant: null,
    modalOpen: false,
  });

  const [powerCartNumbersState, setPowerCartNumbersState] = useState<ICartNumbersState>({
    cartNumbersModalVisible: false,
    cartNumberModalVisible: false,
    selectedPowerCarts: [],
    seatNumbers: [0],
    currentSlot: null,
    availablePowerCarts: [],
    loadedAvailableCarts: false,
  });

  // Remove bookings as a state to reduce a re-render
  const uniqueBookings: IBooking[] = teeSheetStore.selectedTeeTime?.slots
    .map(slot => {
      if (slot.booking && !uniqueBookings?.find(innerSlot => innerSlot.id === slot.id)) {
        return slot.booking;
      }
    })
    .filter((booking, index, array) => array.findIndex(secBooking => secBooking?.id === booking?.id) === index)
    .filter(booking => booking !== undefined);

  useEffect(() => {
    const source = axios.CancelToken.source();
    if (
      uniqueBookings !== undefined &&
      uniqueBookings?.length !== 0 &&
      teeSheetStore.selectedTeeTime?.id === Number(teetimeId)
    ) {
      void updateBookingNotes();
      void loadHighPriorityCustomerNotes(false, source.token);
    }
    return () => source.cancel();
  }, [teeSheetStore.selectedTeeTime?.slots]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    if (powerCartNumbersState.cartNumberModalVisible) {
      if (powerCartNumbersState.selectedPowerCarts.length === 0) {
        void setPowerCarts();
        if (facilityStore.teeSheetSettings?.use_cart_inventory) {
          void loadPowerCartList(source.token);
        }
      }
    }

    return () => source.cancel();
  }, [powerCartNumbersState.cartNumberModalVisible]);

  useEffect(() => {
    if (props.promptCartNumberForSlot) {
      addCartNumber(null, teeSheetStore.selectedTeeTime?.slots, props.promptCartNumberForSlot);
      props.clearPromptCartNumberForSlot();
    }
  }, [props.promptCartNumberForSlot]);

  //NOTES

  const [noteModal, setNoteModal] = useState<{
    isOpen: boolean;
    slot: any;
    content: string;
    highPriority: boolean;
  }>({
    isOpen: false,
    slot: null,
    content: "",
    highPriority: false,
  });

  useEffect(() => {
    console.log("noteModal state changed:", noteModal);
  }, [noteModal]);

  const openPlayerNoteModal = (slot: any) => {
    setNoteModal({
      isOpen: true,
      slot,
      content: "",
      highPriority: false,
    });
  };

  const closePlayerNoteModal = () => {
    setNoteModal(prev => ({
      ...prev,
      isOpen: false,
      slot: null,
      content: "",
      highPriority: false,
    }));
  };

  const savePlayerNote = async () => {
    if (!noteModal.slot) {
      return;
    }

    try {
      await props.createPlayerNote({
        customer_id: noteModal.slot.booking_participant.customer_id,
        content: noteModal.content,
        high_priority: noteModal.highPriority,
        tee_time_booking_id: noteModal.slot.tee_time_booking_id,
      });
      await updateBookingNotes();

      if (noteModal.highPriority) {
        const source = axios.CancelToken.source();
        await loadHighPriorityCustomerNotes(false, source.token);
        source.cancel();
      }

      closePlayerNoteModal();
    } catch (err) {
      console.error("Error saving player note:", err);
      dispatch(showError(t("Failed to save note")));
    }
  };

  const [drawerState, setDrawerState] = useState({
    isOpen: false,
    selectedSlot: null as ISlot | null,
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    customerId: null as number | null,
    customerMemberships: null,
    customerType: "",
    cartCustomerType: "",
    profileImage: null,
  });

  const [drawerSelectedTab, setDrawerSelectedTab] = useState<number>(0);

  const [printLiabilityWaiverSheet, setPrintLiabilityWaiverSheet] = useState<{
    open: boolean;
    loading: boolean;
    waivers: ILiabilityWaiver[] | null;
    selectedWaiverId: number | null;
    customerId: number | null;
  }>({
    open: false,
    loading: false,
    waivers: null,
    selectedWaiverId: null,
    customerId: null,
  });

  useEffect(() => {
    if (!printLiabilityWaiverSheet.open) {
      return;
    }
    const source = axios.CancelToken.source();

    void (async () => {
      const res = await GetLiabilityWaivers(null, false);
      if (source.token.reason) {
        return;
      }
      if (res.status !== StatusCode.OK) {
        dispatch(showError(res.message));
        setPrintLiabilityWaiverSheet(prev => ({ ...prev, loading: false, waivers: [] }));
        return;
      }
      const list = res.data ?? [];
      setPrintLiabilityWaiverSheet(prev => ({
        ...prev,
        loading: false,
        waivers: list,
        selectedWaiverId: list[0]?.id ?? null,
      }));
    })();

    return () => source.cancel();
  }, [printLiabilityWaiverSheet.open]);

  // FUNCTIONS

  async function loadCustomerNotes(globalLoader: boolean, token?: CancelToken) {
    const customerNotesRes = await GetCustomerNotes(
      {
        customer_id: editCustomerState.customerId,
      },
      globalLoader,
      token,
    );

    if (customerNotesRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_display.028")));
      return;
    }

    setNoteState({ notes: customerNotesRes.data });
  }

  async function loadHighPriorityCustomerNotes(globalLoader: boolean, token?: CancelToken) {
    const slots = teeSheetStore.selectedTeeTime?.slots;

    const customerNotes: TCustomerNote[] = [];
    for (const slot of slots) {
      if (!slot.booking_participant) {
        continue;
      }
      if (!slot.booking_participant.guest && slot.booking_participant?.customer?.has_high_priority_notes) {
        const customerNoteRes = await GetCustomerNotes(
          {
            customer_id: slot.booking_participant.customer_id,
            high_priority: true,
          },
          globalLoader,
          token,
        );

        if (token && token.reason) {
          return;
        }
        if (customerNoteRes.status === StatusCode.OK) {
          customerNotes.push(...customerNoteRes.data);
        }
      }
    }

    setHighPriorityNotes(customerNotes);
  }

  function setPowerCarts() {
    const powerCarts = teeSheetStore.selectedTeeTime.slots.map(slot => ({
      power_cart_id: slot.booking_participant?.power_cart_id,
      participant_id: slot.booking_participant?.id,
      seat_number: slot.booking_participant?.seat_number,
      power_cart_number: slot.booking_participant?.power_cart_number,
    }));
    setPowerCartNumbersState(prevState => ({ ...prevState, selectedPowerCarts: powerCarts }));
  }

  async function loadPowerCartList(source: CancelToken) {
    const powerCartRes = await GetPowerCarts(null, false, source);

    const carts = powerCartRes.data;

    const filteredCarts = carts.filter(
      cart =>
        cart.status === "available" ||
        (cart.status === "occupied" &&
          teeSheetStore.selectedTeeTime?.slots.find(slot => slot?.booking_participant?.power_cart_id === cart.id)),
    );

    setPowerCartNumbersState(prevState => ({
      ...prevState,
      availablePowerCarts: filteredCarts,
      loadedAvailableCarts: true,
    }));
  }

  async function updateBookingNotes() {
    const allNotes: TCustomerNote[] = [];

    for (const booking of uniqueBookings) {
      const bookingNotesRes: IAPIResponse = await GetBookingNotes({ tee_time_booking_id: booking.id }, false);

      if (bookingNotesRes.status !== StatusCode.OK) {
        dispatch(showError(bookingNotesRes.message));
        return;
      }

      if (Array.isArray(bookingNotesRes.data) && bookingNotesRes.data.length > 0) {
        const reversed = [...(bookingNotesRes.data as TCustomerNote[])].reverse();
        allNotes.push(...reversed);
      }
    }

    const unique: any[] = [];
    const seen = new Set<number>();

    for (const note of allNotes) {
      if (!seen.has(note.id)) {
        unique.push(note);
        seen.add(note.id);
      }
    }
    setNotes(unique);
  }

  async function updateCustomer() {
    const params = {
      id: editCustomerState.customerId,
      first_name: editCustomerState.customerFirstName,
      last_name: editCustomerState.customerLastName,
      email: editCustomerState.customerEmail,
      phone: editCustomerState.customerPhone,
    };

    const fullName = editCustomerState.customerFirstName + " " + editCustomerState.customerLastName;

    const updateCustomerRes = await PutCustomer(params, true);

    if (updateCustomerRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_display.012")));
      return;
    }

    const bookingParticipantRes = await PutBookingParticipant(
      {
        id: editCustomerState.booking_participant_id,
        first_name: editCustomerState.customerFirstName,
        last_name: editCustomerState.customerLastName,
        full_name: fullName,
      },
      true,
    );

    if (bookingParticipantRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_display.013")));
      return;
    }

    setEditCustomerState(prevState => ({ ...prevState, customerEditVisible: false }));
    dispatch(showSuccess(t("secure.facility.tee_sheet.tee_sheet_booking_display.014")));
    void dispatch(selectTeeTime(parseInt(editCustomerState.teeTimeId), true));
  }

  function addCartNumber(event: React.MouseEvent<Element, MouseEvent>, slots: ISlot[], slot: ISlot) {
    const tempPowerCartNumbers: number[] = [];
    const tempSeatNumbers: number[] = [];

    slots.forEach((slot: any, index: number) => {
      tempPowerCartNumbers[index] = slot?.booking_participant?.power_cart_id;
      tempSeatNumbers[index] = slot?.booking_participant?.seat_number;
    });

    setPowerCartNumbersState(prevState => ({
      ...prevState,
      power_cart_numbers: tempPowerCartNumbers,
      seatNumbers: tempSeatNumbers,
      currentSlot: slot,
      cartNumberModalVisible: true,
    }));
  }

  function handleCustomerDetailsChange(event: any) {
    const { id, value } = event.target;
    setEditCustomerState(prevState => ({ ...prevState, [id]: value }));
  }

  function handleCartIdChange(cartId: number, participant_id: number) {
    const seatNumber =
      powerCartNumbersState?.selectedPowerCarts?.filter(powerCart => powerCart.power_cart_id === cartId).length + 1;

    const powerCartList = !powerCartNumbersState.selectedPowerCarts.some(cart => cart.participant_id === participant_id)
      ? [
        ...powerCartNumbersState.selectedPowerCarts,
        { power_cart_id: cartId, participant_id: participant_id, seat_number: seatNumber, power_cart_number: null },
      ]
      : powerCartNumbersState.selectedPowerCarts.map(powerCart =>
        participant_id === powerCart.participant_id
          ? { ...powerCart, power_cart_id: cartId, seat_number: seatNumber, power_cart_number: null }
          : powerCart,
      );

    setPowerCartNumbersState(prevState => ({ ...prevState, selectedPowerCarts: powerCartList }));
  }

  function handleCartNumberChange(cartNumber: number, participant_id: number) {
    const seatNumber =
      powerCartNumbersState?.selectedPowerCarts?.filter(powerCart => powerCart.power_cart_number === cartNumber)
        .length + 1;

    const powerCartList = !powerCartNumbersState.selectedPowerCarts.some(cart => cart.participant_id === participant_id)
      ? [
        ...powerCartNumbersState.selectedPowerCarts,
        {
          power_cart_id: null,
          participant_id: participant_id,
          seat_number: seatNumber,
          power_cart_number: cartNumber,
        },
      ]
      : powerCartNumbersState.selectedPowerCarts.map(powerCart =>
        participant_id === powerCart.participant_id
          ? { ...powerCart, power_cart_id: null, seat_number: seatNumber, power_cart_number: cartNumber }
          : powerCart,
      );

    setPowerCartNumbersState(prevState => ({ ...prevState, selectedPowerCarts: powerCartList }));
  }

  async function saveCartNumber(bookingParticipant: IBookingParticipant) {
    const cartParticipant = powerCartNumbersState.selectedPowerCarts.find(
      cart => bookingParticipant.id === cart.participant_id,
    );
    if (cartParticipant) {
      const participantRes = await PutBookingParticipant(
        {
          id: bookingParticipant.id,
          power_cart_id: cartParticipant.power_cart_id,
          seat_number: cartParticipant.seat_number,
          power_cart_number: cartParticipant.power_cart_number,
        },
        true,
      );

      if (participantRes.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_display.030")));
        return;
      }
      setPowerCartNumbersState(prevState => ({ ...prevState, cartNumberModalVisible: false }));
      props.reloadTeeTimes();
    }
  }

  function confirmNoShowSelection() {
    props.noShowBookingHandler(
      noShowModal.slot,
      noShowModal.type,
      noShowModal.markAllPlayers ? noShowModal.allSlotIds : null,
      noShowModal.sendNoShowChargeEmail,
    );
    closeNoShowModal();
  }

  function handleInitiateEditName(slot: ISlot) {
    setEditName(prevState => ({
      ...prevState,
      selectedBookingParticipant: slot?.booking_participant,
      newName: slot?.booking_participant?.full_name,
      modalOpen: true,
    }));
  }

  function handleEditNameChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { id, value } = e.target;
    setEditName(prevState => ({ ...prevState, [id]: value }));
  }

  async function handleEditName() {
    if (!editName) {
      return;
    }

    const [firstName, lastName] = editName.newName.split(" ");
    const participantRes = await PutBookingParticipant(
      { id: editName?.selectedBookingParticipant?.id, first_name: firstName ?? "", last_name: lastName ?? "" },
      true,
    );
    if (participantRes?.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_display.031")));
      return;
    }
    dispatch(showSuccess(t("secure.facility.tee_sheet.tee_sheet_booking_display.032")));
    void dispatch(selectTeeTime(teeSheetStore?.selectedTeeTime?.id, true));
    setEditName(prevState => ({ ...prevState, newName: "", selectedBookingParticipant: null, modalOpen: false }));
  }

  //DRAWER

  async function openDrawer(slot: ISlot) {
    const phoneNumberString = slot.booking_participant.customer.phone || "";

    setDrawerState({
      isOpen: true,
      selectedSlot: slot,
      firstName: slot.booking_participant.customer.first_name,
      lastName: slot.booking_participant.customer.last_name,
      email: slot.booking_participant.customer.email,
      phone: phoneNumberString,
      customerId: slot.booking_participant.customer_id,
      customerMemberships: null,
      customerType: slot.booking_participant?.customer?.customer_type,
      cartCustomerType: slot.booking_participant?.customer?.cart_customer_type,
      profileImage: slot.booking_participant?.customer.profile_image_source,
    });

    if (!slot.booking_participant?.guest) {
      const membershipRes = await GetCustomerMemberships({ customer_id: slot.booking_participant.customer.id }, false);

      if (membershipRes.status === StatusCode.OK) {
        setDrawerState(prevState => ({
          ...prevState,
          customerMemberships: membershipRes,
        }));
      }

      // Load customer notes
      const customerNotesRes = await GetCustomerNotes(
        {
          customer_id: slot.booking_participant.customer_id,
        },
        false,
      );

      if (customerNotesRes.status === StatusCode.OK) {
        setNoteState({ notes: customerNotesRes.data });
      }
    }
  }

  //CLOSE DRAWER
  function closeDrawer() {
    setDrawerState({
      isOpen: false,
      selectedSlot: null,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      customerId: null,
      customerMemberships: null,
      customerType: "",
      cartCustomerType: "",
      profileImage: null,
    });
    setDrawerSelectedTab(0);
    setNoteState(null);
  }

  //HANDLE DRAWER DETAILS CHANGE
  function handleDrawerDetailsChange(event: any) {
    const { id, value } = event.target;
    setDrawerState(prevState => ({ ...prevState, [id]: value }));
  }

  //HANDLE CONFIRM DRAWER
  async function handleDrawerConfirm() {
    const params = {
      id: drawerState.customerId,
      first_name: drawerState.firstName,
      last_name: drawerState.lastName,
      email: drawerState.email,
      phone: drawerState.phone,
    };

    const fullName = drawerState.firstName + " " + drawerState.lastName;

    const updateCustomerRes = await PutCustomer(params, true);

    if (updateCustomerRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_display.012")));
      return;
    }

    const bookingParticipantRes = await PutBookingParticipant(
      {
        id: drawerState.selectedSlot.booking_participant.id,
        first_name: drawerState.firstName,
        last_name: drawerState.lastName,
        full_name: fullName,
      },
      true,
    );

    if (bookingParticipantRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_display.013")));
      return;
    }

    dispatch(showSuccess(t("secure.facility.tee_sheet.tee_sheet_booking_display.014")));
    void dispatch(selectTeeTime(teeSheetStore?.selectedTeeTime?.id, true));
    closeDrawer();
  }

  async function handleQuickRedeemTicket(stub: IStub, customerId: number, participantId: number, bookingId: number) {
    const selectedBookingParticipantIndex = teeSheetStore?.selectedTeeTime?.slots?.findIndex(
      slot => slot?.booking_participant?.id == participantId,
    );

    const redeemedStubs = [stub];

    const bookingSlots = [...teeSheetStore.selectedTeeTime.slots];
    //Order the slots so that the next participant after the current one has the ticket applied, then continue from the first participant in the booking
    const slotsOrderUpdate = [
      ...bookingSlots.slice(selectedBookingParticipantIndex, bookingSlots?.length),
      ...bookingSlots.slice(0, selectedBookingParticipantIndex),
    ];

    //Filter out participants whose green fees are already paid (booking-fee-only still eligible)
    const filteredSlots = slotsOrderUpdate?.filter(slot =>
      isSlotEligibleForTicketFeeRedemption(slot, bookingId),
    );

    //Set the participant ids in an array
    const participantIds = filteredSlots?.map(slot => slot?.booking_participant?.id);

    for (let i = 0; i < redeemedStubs.length; i++) {
      const greenFeeProduct = redeemedStubs[i].redemption_product?.green_fee || null;
      const powerCartProduct = redeemedStubs[i].redemption_product?.power_cart || null;

      const greenFeeQuantity = Number(greenFeeProduct?.pivot?.quantity);
      const powerCartQuantity = Number(powerCartProduct?.pivot?.quantity);

      if (
        ((greenFeeProduct && greenFeeQuantity >= 1) || (powerCartProduct && powerCartQuantity >= 1)) &&
        participantIds?.length > 0
      ) {
        //Get the max quantity between the green fee & power cart
        const higherQuantity =
          greenFeeQuantity && powerCartQuantity
            ? Math.max(greenFeeQuantity, powerCartQuantity)
            : greenFeeQuantity
              ? greenFeeQuantity
              : powerCartQuantity;

        let currentGreenFeeAmount = greenFeeQuantity;
        let currentPowerCartAmount = powerCartQuantity;

        for (const i of [...Array(higherQuantity).keys()]) {
          const putBookingParticipantRes = await PutBookingParticipant(
            {
              id: participantIds[0],
              green_fee_variant_id:
                greenFeeProduct && currentGreenFeeAmount >= 1 ? greenFeeProduct?.pivot?.variant_id : undefined,
              power_cart_variant_id:
                powerCartProduct && currentPowerCartAmount >= 1 ? powerCartProduct?.pivot?.variant_id : undefined,
            },
            true,
          );

          if (putBookingParticipantRes.status !== StatusCode.OK) {
            dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.182")));
            return;
          }

          //Remove the first booking participant in the array to move onto the next participant
          participantIds.shift();
          //Decrement the green fee / power cart quantity
          currentGreenFeeAmount -= 1;
          currentPowerCartAmount -= 1;
          //If the max quantity between the green fee / power cart is reached or there are no participants left to apply the ticket,
          //break out of the loop and redeem the ticket and close the modal
          if (i === higherQuantity - 1 || participantIds?.length === 0) {
            break;
          }
        }
      }
    }

    dispatch(showSuccess(t("Ticket Redeemed Successfully")));

    if (redeemedStubs?.length > 0) {
      const foundSlot = teeSheetStore?.selectedTeeTime?.slots?.find(slot => slot?.booking_participant.id === participantId);
      const pendingStubIds = foundSlot ? foundSlot?.booking_participant?.pending_ticket_stub_ids : [];
      const allPendingStubs = pendingStubIds && pendingStubIds?.length > 0 ? [...pendingStubIds, ...redeemedStubs.map(stub => stub?.id)] : redeemedStubs?.map(stub => stub?.id);
      const res = await PutBookingParticipant(
        {
          id: participantId,
          pending_ticket_stub_ids: allPendingStubs,
        },
        true,
      );
      if (res?.status !== StatusCode.OK) {
        dispatch(showError(errorMessage(res, t("Error setting ticket stubs pending state"))));
      }
    }

    props.closeReviewPlayersModal();
    // Reload the tee times
    void dispatch(selectTeeTime(parseInt(teetimeId), true));
  }

  return (
    <>
      <div className="booking-list booking-card">
        {uniqueBookings !== undefined &&
          uniqueBookings?.map(booking => {
            return (
              <div key={booking?.id}>
                {/* HEADER */}
                <div className="booking-card-header">
                  <div className="booking-card-title">
                    {t("secure.facility.tee_sheet.tee_sheet_booking_display.001")}
                    {booking?.confirmation_number}
                  </div>

                  <div style={{ display: "flex", gap: "1px" }}>
                    {teeSheetStore.selectedTeeTime?.quantity_remaining > 0 && (
                      <>
                        <Button type="text" onClick={() => props.initiateEditBookingHandler(booking, true)}>
                          {t("secure.facility.tee_sheet.tee_sheet_booking_display.011")}
                        </Button>

                        <div className="vertical-line"></div>
                      </>
                    )}

                    <Button
                      type="text"
                      onClick={() => props.initiateEditBookingHandler(booking)}
                      disabled={!!order || props?.cart?.line_items?.length > 0}
                    >
                      {t("Edit booking")}
                    </Button>
                  </div>
                </div>

                {/* PLAYER LIST */}
                <div className="booking-player-list">
                  {teeSheetStore.selectedTeeTime?.slots
                    .filter(slot => slot.booking?.id === booking?.id)
                    .map((slot, index) => {

                      const customerNotesForPlayer =
                        highPriorityNotes?.filter(
                          n =>
                            n.customer_id === slot.booking_participant?.customer_id && !slot.booking_participant?.guest,
                        ) ?? [];

                      const bookingNotesForPlayer =
                        notes?.filter(n => {
                          const hasParticipant = n?.tee_time_booking_participant_id != null;

                          const matchesParticipant = n?.tee_time_booking_participant_id === slot?.booking_participant?.id;

                          const matchesBooking =
                            !hasParticipant &&
                            n?.tee_time_booking_id === slot?.booking?.id &&
                            index === 0;

                          return matchesParticipant || matchesBooking;

                        }) ?? [];

                      const totalNotes = customerNotesForPlayer.length + bookingNotesForPlayer.length;

                      const hasAnyNotes = totalNotes > 0;

                      const currentParticipant = participantPaidFees?.current.find(
                        participant => participant?.booking_participant_id === slot?.booking_participant?.id,
                      );

                      const green_fee_added =
                        currentParticipant?.green_fee || currentParticipant?.green_fee === undefined;

                      const power_cart_fee_added =
                        currentParticipant?.power_cart_fee || currentParticipant?.power_cart_fee === undefined;

                      return (
                        <Fragment key={index}>
                          {slot.status === "booked" ? (
                            <div className="player-group">
                              <div className="player-header">
                                {/* LEFT SIDE */}
                                <div className="player-left">
                                  {/* Avatar */}
                                  <div className="player-avatar">
                                    {!slot?.booking_participant?.guest &&
                                      slot?.booking_participant?.customer.profile_image_source !== null ? (
                                      <img
                                        onClick={() => openDrawer(slot)}
                                        src={
                                          !slot?.booking_participant?.guest &&
                                            slot?.booking_participant?.customer.profile_image_source !== null
                                            ? slot?.booking_participant?.customer?.profile_image_source
                                            : "/public/images/default_profile_image.svg"
                                        }
                                        alt={t("customer_image")}
                                      />
                                    ) : (
                                      <div className="player-avatar-initials" onClick={() => openDrawer(slot)}>
                                        {slot.booking_participant.customer?.first_name.charAt(0)}
                                        {slot.booking_participant.customer?.last_name.charAt(0)}
                                      </div>
                                    )}
                                  </div>

                                  <div className="player-info">
                                    {/* NAME + STATUS ICONS ON SAME ROW */}

                                    <div className="player-name-row">
                                      <div
                                        className="player-name flex items-center gap-3"
                                        onClick={() => props.showChangePlayerHandler(slot.booking_participant)}
                                      >
                                        {slot.booking_participant?.full_name}
                                        {slot?.booking_participant?.riding ? (
                                          <img
                                            className="w-4 h-4"
                                            src="../../../public/images/powercart2-01.svg"
                                            alt="Riding"
                                          />
                                        ) : (
                                          <FontAwesomeIcon icon={faPersonWalking} />
                                        )}
                                      </div>

                                      <div className="player-status">
                                        {slot?.booking_participant?.pre_paid ? (
                                          <Badge size="small" colour="#5925DC" outline>
                                            {t("Prepaid")}
                                          </Badge>
                                        ) : null}

                                        {/* THIRD PARTY BOOKINGS */}
                                        <BookingSourceLogo source={slot.tee_time_bookings_source} />

                                        {slot?.booking_participant?.finish_time ? (
                                           <OverlayTrigger
                                           placement="top"
                                           overlay={
                                             <Tooltip id="finish-time-tooltip" className="tee_off_tooltip">
                                               {t("Finish time recorded at")}{" "}
                                               {moment
                                                 .utc(slot?.booking_participant?.finish_time, "YYYY-MM-DD HH:mm:ss")
                                                 .local()
                                                 .format("LT")}
                                             </Tooltip>
                                           }
                                         >
                                           <FontAwesomeIcon icon={faFlag} className="booking-participant_icon" />
                                         </OverlayTrigger>
                                        ) : slot?.booking_participant?.turn_time ? (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={
                                              <Tooltip id="turn-time-tooltip" className="tee_off_tooltip">
                                                {t("Turn time recorded at")}{" "}
                                                {moment
                                                  .utc(slot.booking_participant?.turn_time, "YYYY-MM-DD HH:mm:ss")
                                                  .local()
                                                  .format("LT")}
                                              </Tooltip>
                                            }
                                          >
                                            <FontAwesomeIcon icon={faArrowUTurnUpRight} className="booking-participant_icon" />
                                          </OverlayTrigger>
                                        ) : slot?.booking_participant?.tee_off_time ? (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={
                                              <Tooltip id="tee-off-time-tooltip" className="tee_off_tooltip">
                                                {t("Tee off recorded at")}{" "}
                                                {moment
                                                  .utc(slot.booking_participant?.tee_off_time, "YYYY-MM-DD HH:mm:ss")
                                                  .local()
                                                  .format("LT")}
                                              </Tooltip>
                                            }
                                          >
                                            <FontAwesomeIcon icon={faPersonGolfing} className="booking-participant_icon" />
                                          </OverlayTrigger>
                                        ) : slot.booking_participant.check_in_status === "checked" && (
                                          <span>
                                            {/* CHECKED IN */}
                                            <div className="checked-in-participant">
                                              <FontAwesomeIcon
                                                icon={faCheckCircle}
                                                className="booking-participant_icon booking-participant_icon_checked"
                                              />
                                            </div>
                                          </span>
                                        )}

                                        {/* REMINDER CONFIRMED */}
                                        {slot.booking_participant.check_in_status !== "checked" &&
                                          slot.booking_participant.check_in_status !== "arrived" &&
                                          !slot.booking_participant.no_show &&
                                          !slot.booking_participant.no_show_weather &&
                                          slot.booking_participant.reminder_confirmed_at && (
                                            <span>
                                              <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id={"confirmed-icon"}>{t("Confirmed")}</Tooltip>}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faMessageCheck}
                                                  className="booking-participant_icon"
                                                />
                                              </OverlayTrigger>
                                            </span>
                                          )}

                                        {/* ARRIVED */}
                                        {slot.booking_participant.check_in_status === "arrived" && (
                                          <span>
                                            <FontAwesomeIcon
                                              icon={faLocationCheck}
                                              className="booking-participant_icon"
                                            />
                                          </span>
                                        )}

                                        {/* PAID */}
                                        {slot.booking_participant.order_financial_status === "paid" && (
                                          <span>
                                            <div className="paid-order-participant">
                                              <FontAwesomeIcon
                                                icon={faUsdCircle}
                                                className="booking-participant_icon_paid"
                                              />
                                            </div>
                                          </span>
                                        )}

                                        {/* NO SHOW */}
                                        {slot.booking_participant.no_show === true && (
                                          <span className="mr-2 flex items-center">
                                            <div className="no-show-icon">
                                              <FontAwesomeIcon icon={["far", "ban"]} className="no-show-icon-content" />
                                            </div>

                                            <div>
                                              <Badge size="small" colour="#FDB022" outline>
                                                {slot?.booking_participant?.no_show_type === "defer"
                                                  ? t("secure.facility.tee_sheet.tee_sheet_booking_display.039")
                                                  : valueToString(slot?.booking_participant?.no_show_type)}
                                              </Badge>
                                            </div>
                                          </span>
                                        )}

                                        {/* WEATHER NO SHOW */}
                                        {slot.booking_participant.no_show_weather === true && (
                                          <span className="mr-2 flex items-center">
                                            <FontAwesomeIcon
                                              icon={["far", "thunderstorm"]}
                                              className="booking-participant_icon booking-participant_icon_weather mr-2"
                                            />
                                            <Badge size="small" colour="#FDB022" outline>
                                              {slot?.booking_participant?.no_show_type === "defer"
                                                ? t("secure.facility.tee_sheet.tee_sheet_booking_display.039")
                                                : valueToString(slot?.booking_participant?.no_show_type)}
                                            </Badge>
                                          </span>
                                        )}

                                        {/* CUSTOMER TAGS */}
                                        {slot.booking_participant?.customer?.tags?.length > 0 &&
                                          !slot.booking_participant?.guest && (
                                            <div className="player-tags">
                                              {slot.booking_participant.customer.tags.map((tag, index) => (
                                                <OverlayTrigger
                                                  key={index}
                                                  placement="top"
                                                  overlay={
                                                    tag.description ? (
                                                      <Tooltip
                                                        id={`customer-tag-${index}-${slot.booking_participant?.customer?.id}`}
                                                      >
                                                        {tag.description}
                                                      </Tooltip>
                                                    ) : (
                                                      <div />
                                                    )
                                                  }
                                                >
                                                  <div>
                                                    <Badge colour={tag.colour} outline size="small">
                                                      {tag.label}
                                                    </Badge>
                                                  </div>
                                                </OverlayTrigger>
                                              ))}
                                            </div>
                                          )}
                                      </div>
                                    </div>

                                    <div className="player-subline">
                                      <span className="player-role">
                                        {slot.booking_participant.guest
                                          ? t("secure.facility.tee_sheet.tee_sheet_booking_display.015") // "Guest"
                                          : slot.booking_participant.customer?.customer_type}
                                      </span>
                                      {slot.booking_participant.customer?.cart_customer_type &&
                                        !slot.booking_participant.guest && <span className="player-role">•</span>}

                                      {slot.booking_participant.customer?.cart_customer_type &&
                                        !slot.booking_participant.guest && (
                                          <span className="player-role">
                                            {slot.booking_participant.customer.cart_customer_type}
                                          </span>
                                        )}

                                      {slot?.booking_participant?.order_id && (
                                        <span
                                          className="player-order-link"
                                          onClick={() =>
                                            history.push("/admin/order/" + String(slot.booking_participant.order_id))
                                          }
                                        >
                                          {t("secure.facility.tee_sheet.tee_sheet_booking_display.023")}{" "}
                                          {slot.booking_participant.order_name}{" "}
                                          {slot.booking_participant.order_financial_status}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <NavigationDropdownNew
                                  showPlainTextLabel
                                  rightAlign
                                  label={<FontAwesomeIcon icon={faEllipsisVertical} />}
                                  sections={[
                                    [
                                      {
                                        hidden: slot?.booking_participant?.guest,
                                        label: t("secure.facility.tee_sheet.tee_sheet_booking_display.025"),
                                        icon: "magnifying-glass",
                                        onClick: () =>
                                          history.push(
                                            "/admin/customers/" +
                                            String(slot?.booking_participant?.customer_id) +
                                            "/profile",
                                          ),
                                      },

                                      {
                                        icon: "note-sticky",
                                        label: "Add note",
                                        onClick: () => openPlayerNoteModal(slot),
                                      },

                                      {
                                        icon: "circle-check",
                                        label: t("secure.facility.tee_sheet.tee_sheet_booking_display.026"),
                                        onClick: () => props.checkInHandler(slot),
                                      },

                                      {
                                        icon: "ban",
                                        label: t("secure.facility.tee_sheet.tee_sheet_booking_display.027"),
                                        onClick: () => {
                                          updateNoShowModal({
                                            slot: slot,
                                            isOpen: true,
                                            allSlotIds: teeSheetStore?.selectedTeeTime?.slots
                                              .filter(
                                                val =>
                                                  (val?.booking?.id === booking?.id &&
                                                    val?.booking_participant?.check_in_status === "unchecked") ||
                                                  val?.booking_participant?.check_in_status === "no_show",
                                              )
                                              .map(slot => slot?.tee_time_booking_participant_id),
                                          });
                                        },
                                      },

                                      {
                                        icon: "rotate-left",
                                        label: "Remove No Show",
                                        onClick: () => props.removeNoShowBookingHandler(slot),
                                        hidden:
                                          !slot.booking_participant.no_show &&
                                          !slot.booking_participant.no_show_weather,
                                      },

                                      {
                                        icon: "dollar-sign",
                                        label: t("secure.facility.tee_sheet.tee_sheet_booking_display.005"),
                                        onClick: () => props.chargeNoShowHandler(slot),
                                        hidden:
                                          !permissions.tee_sheet_charge_no_show ||
                                          slot.booking_participant.no_show_type === "weather" ||
                                          slot.booking_participant.no_show_type === null,
                                      },

                                      {
                                        hidden: !slot?.booking_participant?.guest,
                                        icon: "pen-to-square",
                                        label: t("secure.facility.tee_sheet.tee_sheet_booking_display.038"),
                                        onClick: () => handleInitiateEditName(slot),
                                      },

                                      {
                                        icon: "umbrella",
                                        label: "Rain check",
                                        onClick: () => props.initiateIssueRainCheckHandler(slot),
                                        hidden:
                                          slot.booking_participant.check_in_status !== "checked" ||
                                          slot.booking_participant.order_financial_status !== "paid" ||
                                          slot.booking_participant.rain_check_green_fee_issued,
                                      },
                                    ],

                                    [
                                      {
                                        icon: "right-left",
                                        label: t("secure.facility.tee_sheet.tee_sheet_booking_display.006"),
                                        onClick: () => props.showChangePlayerHandler(slot.booking_participant),
                                      },

                                      {
                                        icon: "user-slash",
                                        label: t("secure.facility.tee_sheet.tee_sheet_booking_display.007"),
                                        onClick: () => props.cancelBookingParticipantHandler(slot),
                                      },

                                      {
                                        icon: "print",
                                        label: t("secure.facility.tee_sheet.tee_sheet_booking_display.008"),
                                        onClick: () =>
                                          props.loadCartWaiverHandler(slot?.booking_participant?.customer_id),
                                      },
                                      {
                                        icon: "print",
                                        label: t("Print Liability Waiver"),
                                        onClick: () =>
                                          setPrintLiabilityWaiverSheet({
                                            open: true,
                                            loading: true,
                                            waivers: null,
                                            selectedWaiverId: null,
                                            customerId: slot?.booking_participant?.customer_id ?? null,
                                          }),
                                      },

                                      {
                                        icon: "ticket",
                                        label: t("secure.facility.tee_sheet.tee_sheet_booking_display.009"),
                                        onClick: () => props.initiateRedeemTicketHandler(slot),
                                      },
                                    ],

                                    [],
                                  ]}
                                />
                              </div>

                              <div className="fees-section">
                                <div className="fee-row">
                                  {/* GREEN FEE BOX */}
                                  <div
                                    className={`fee-box ${slot.booking_participant.green_fee_paid ? "fee-box-paid" : ""
                                      }`}
                                    onClick={e =>
                                      props.initiateAddFeeHandler(
                                        e,
                                        slot,
                                        "Green Fee",
                                        green_fee_added || currentParticipant?.green_fee_loading,
                                        undefined,
                                        !!order,
                                      )
                                    }
                                  >
                                    <div>
                                      <div className="fee-label">
                                        {slot.booking_participant.green_fee_product_title || "No Green Fee"}
                                        {slot.booking_participant.green_fee_paid && (
                                          <Badge size="small" type="success" className="ml-2">
                                            Paid
                                          </Badge>
                                        )}
                                      </div>

                                      {slot.booking_participant.green_fee_product_title &&
                                        slot.booking_participant.green_fee_product_title !==
                                        slot.booking_participant.green_fee_variant_title && (
                                          <div className="fee-subtext">
                                            {slot.booking_participant.green_fee_variant_title}
                                          </div>
                                        )}
                                    </div>

                                    <Button
                                      className={`fee-action-btn ${slot.booking_participant.green_fee_paid ? "fee-paid" : ""
                                        }`}
                                      type={
                                        slot.booking_participant.green_fee_paid
                                          ? "secondary"
                                          : green_fee_added && !slot.booking_participant.green_fee_paid
                                            ? "primary"
                                            : "secondary"
                                      }
                                      icon={
                                        currentParticipant?.green_fee_loading ? (
                                          <FontAwesomeIcon size="1x" icon={faSpinnerThird} spin fade />
                                        ) : slot.booking_participant.green_fee_paid ? (
                                          <FontAwesomeIcon icon={faCheck} />
                                        ) : green_fee_added ? (
                                          <FontAwesomeIcon icon={faCheck} />
                                        ) : (
                                          <FontAwesomeIcon icon={faPlus} />
                                        )
                                      }
                                      onClick={e => {
                                        // Don't allow clicks when paid
                                        if (slot.booking_participant.green_fee_paid) {
                                          e.stopPropagation();
                                          return;
                                        }

                                        if (!green_fee_added) {
                                          void addFeeHandler(
                                            slot,
                                            {
                                              id: slot?.booking_participant?.green_fee_variant_id,
                                              variantTitle: slot?.booking_participant?.green_fee_variant_title,
                                              productTitle: slot?.booking_participant?.green_fee_product_title,
                                            },
                                            null,
                                            e,
                                          );
                                        } else {
                                          void removeFeeHandler(
                                            slot,
                                            slot?.booking_participant?.green_fee_variant_id,
                                            "green_fee",
                                            e,
                                          );
                                        }
                                      }}
                                      disabled={
                                        !slot?.booking_participant?.green_fee_variant_id ||
                                        currentParticipant?.green_fee_loading ||
                                        orderProgress.orderStep === OrderProgress.CREATING_CART ||
                                        !!order ||
                                        slot.booking_participant.green_fee_paid // Keep disabled when paid
                                      }
                                    />
                                  </div>

                                  {/* POWER CART BOX */}
                                  <div
                                    className={`fee-box ${slot.booking_participant.power_cart_paid ? "fee-box-paid" : ""
                                      }`}
                                    onClick={e =>
                                      props.initiateAddFeeHandler(
                                        e,
                                        slot,
                                        "Power Cart",
                                        green_fee_added,
                                        power_cart_fee_added || currentParticipant?.power_cart_fee_loading,
                                        !!order,
                                      )
                                    }
                                  >
                                    <div>
                                      <div className="fee-label">
                                        {slot.booking_participant.power_cart_product_title ||
                                          t("secure.facility.tee_sheet.tee_sheet_booking_display.024")}
                                        {slot.booking_participant.power_cart_paid && (
                                          <Badge size="small" type="success" className="ml-2">
                                            Paid
                                          </Badge>
                                        )}
                                      </div>

                                      {slot.booking_participant.power_cart_product_title &&
                                        slot.booking_participant.power_cart_product_title !==
                                        slot.booking_participant.power_cart_variant_title && (
                                          <div className="fee-subtext">
                                            {slot.booking_participant.power_cart_variant_title}
                                          </div>
                                        )}
                                    </div>

                                    <Button
                                      className={`fee-action-btn ${slot.booking_participant.power_cart_paid ? "fee-paid" : ""
                                        }`}
                                      type={
                                        slot.booking_participant.power_cart_paid
                                          ? "secondary"
                                          : power_cart_fee_added && !slot.booking_participant.power_cart_paid
                                            ? "primary"
                                            : "secondary"
                                      }
                                      icon={
                                        currentParticipant?.power_cart_fee_loading ? (
                                          <FontAwesomeIcon size="1x" icon={faSpinnerThird} spin fade />
                                        ) : slot.booking_participant.power_cart_paid ? (
                                          <FontAwesomeIcon icon={faCheck} />
                                        ) : power_cart_fee_added ? (
                                          <FontAwesomeIcon icon={faCheck} />
                                        ) : (
                                          <FontAwesomeIcon icon={faPlus} />
                                        )
                                      }
                                      onClick={e => {
                                        // Don't allow clicks when paid
                                        if (slot.booking_participant.power_cart_paid) {
                                          e.stopPropagation();
                                          return;
                                        }

                                        if (!power_cart_fee_added) {
                                          if (facilityStore?.teeSheetSettings?.track_cart_numbers) {
                                            addCartNumber(e, teeSheetStore.selectedTeeTime?.slots, slot);
                                          } else {
                                            void addFeeHandler(
                                              slot,
                                              null,
                                              {
                                                id: slot?.booking_participant?.power_cart_variant_id,
                                                variantTitle: slot?.booking_participant?.power_cart_variant_title,
                                                productTitle: slot?.booking_participant?.power_cart_product_title,
                                              },
                                              e,
                                            );
                                          }
                                        } else {
                                          void removeFeeHandler(
                                            slot,
                                            slot?.booking_participant?.power_cart_variant_id,
                                            "power_cart_fee",
                                            e,
                                          );
                                        }
                                        e.stopPropagation();
                                      }}
                                      disabled={
                                        !slot?.booking_participant?.power_cart_variant_id ||
                                        currentParticipant?.power_cart_fee_loading ||
                                        orderProgress.orderStep === OrderProgress.CREATING_CART ||
                                        !!order ||
                                        slot.booking_participant.power_cart_paid
                                      }
                                    />
                                  </div>

                                  {!(
                                    slot?.booking_participant?.green_fee_paid &&
                                    slot?.booking_participant?.power_cart_paid
                                  ) && (
                                      <Button
                                        className="fee-cart-btn"
                                        type="primary"
                                        size="medium"
                                        icon={<FontAwesomeIcon icon={faCartShopping} />}
                                        onClick={e =>
                                          void addFeeHandler(
                                            slot,
                                            {
                                              id: slot?.booking_participant?.green_fee_variant_id,
                                              variantTitle: slot?.booking_participant?.green_fee_variant_title,
                                              productTitle: slot?.booking_participant?.green_fee_product_title,
                                            },
                                            {
                                              id: slot?.booking_participant?.power_cart_variant_id,
                                              variantTitle: slot?.booking_participant?.power_cart_variant_title,
                                              productTitle: slot?.booking_participant?.power_cart_product_title,
                                            },
                                            e,
                                          )
                                        }
                                        disabled={
                                          (slot?.booking_participant?.green_fee_paid &&
                                            slot?.booking_participant?.power_cart_paid) ||
                                          (green_fee_added && power_cart_fee_added) ||
                                          orderProgress.orderStep === OrderProgress.CREATING_CART ||
                                          !!order
                                        }
                                      />
                                    )}
                                </div>
                              </div>

                              {/* NOTES AREA - ALWAYS VISIBLE */}

                              {totalNotes > 0 ? (
                                <>
                                  <div className="notes-header">Notes ({totalNotes})</div>
                                  {hasAnyNotes && !slot.booking_participant.guest && (
                                    <div>
                                      <div className="notes-container">
                                        {[...customerNotesForPlayer, ...bookingNotesForPlayer].map((note, i) => (
                                          <div key={i} className="note-box">
                                            {note.high_priority && (
                                              <Badge
                                                iconLeft={
                                                  <FontAwesomeIcon
                                                    size="1x"
                                                    icon={faExclamationCircle}
                                                    style={{ color: "#dc2626" }}
                                                  />
                                                }
                                                size="small"
                                                type="error"
                                              >
                                                {t("High")}
                                              </Badge>
                                            )}
                                            <div className="note-content">{note.content}</div>
                                            <div className="note-header">
                                              <span className="note-date">
                                                {t("Posted on")} {moment(note?.created_at as string).format("LLL")} {t("by")}{" "}
                                                {note?.author?.full_name}
                                              </span>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                      {/* Add note button */}
                                      {/* <Button
                    type="tertiary"
                    onClick={() => openPlayerNoteModal(slot)}
                    className="mt-2"
                    >
                      <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <FontAwesomeIcon icon={faPlus} />
                          Add note
                        </span>
                  </Button> */}
                                    </div>
                                  )}
                                </>
                              ) : null}
                            </div>
                          ) : null}
                        </Fragment>
                      );
                    })}
                </div>
              </div>
            );
          })}
      </div>

      <Sheet
        size="small"
        closable
        title={
          <>
            {t("Add a player note to:")}{" "}
            <Badge size="medium" className="font-semibold">
              {noteModal.slot?.booking_participant?.full_name}
            </Badge>
          </>
        }
        open={noteModal.isOpen}
        okText={t("Save & apply")}
        cancelText={t("Cancel")}
        onOk={savePlayerNote}
        onCancel={closePlayerNoteModal}
        okDisabled={!noteModal.content.trim()}
      >
        <div className="flex flex-col gap-4" style={{ marginTop: 8 }}>
          {/* NOTE FIELD */}
          <TextField
            value={noteModal.content}
            placeholder={t("Write a note about this player…")}
            rows={5}
            autoFocus
            noResize
            showCharacterCount
            maxLength={500}
            onChange={e => setNoteModal(prev => ({ ...prev, content: e.target.value }))}
          />

          <Toggle
            size="small"
            checked={noteModal.highPriority}
            labelRight={t("Set note to high priority")}
            onChange={e =>
              setNoteModal(prev => ({
                ...prev,
                highPriority: e.target.checked,
              }))
            }
          />
        </div>
      </Sheet>

      {/* Player Details Drawer */}
      <Drawer
        open={drawerState.isOpen}
        title="Edit customer details"
        onClose={closeDrawer}
        onOk={handleDrawerConfirm}
        okText="Update details"
        backDropClose={true}
        showCancel={true}
        cancelText="Cancel"
        okDisabled={
          drawerState.firstName === "" ||
          drawerState.lastName === "" ||
          (drawerState.email === "" && drawerState.phone === "")
        }
      >
        {drawerState.selectedSlot && (
          <>
            <Drawer.Section>
              <div className="flex flex-col items-center">
                <img
                  className="w-32 h-32 rounded-full mb-3"
                  src={
                    drawerState.profileImage !== null
                      ? drawerState.profileImage
                      : "/public/images/default_profile_image.svg"
                  }
                  alt={t("customer_image")}
                />
                <Badge size="small" type="gray">
                  {drawerState.customerType && <span>{drawerState.customerType}</span>}
                  {drawerState.cartCustomerType && <span> - {drawerState.cartCustomerType}</span>}
                </Badge>
              </div>
            </Drawer.Section>

            <Drawer.Section>
              <FormLayout>
                <FormLayout.Group>
                  <Input
                    value={drawerState.firstName}
                    label="First name"
                    onChange={handleDrawerDetailsChange}
                    id="firstName"
                    placeholder="First name"
                  />
                  <Input
                    value={drawerState.lastName}
                    label="Last name"
                    onChange={handleDrawerDetailsChange}
                    id="lastName"
                    placeholder="Last name"
                  />
                </FormLayout.Group>

                <FormLayout.Group>
                  <Input
                    value={drawerState.email}
                    label="Email"
                    onChange={handleDrawerDetailsChange}
                    id="email"
                    placeholder="Email address"
                  />

                  <Input
                    value={drawerState.phone}
                    label="Phone number"
                    onChange={handleDrawerDetailsChange}
                    id="phone"
                    placeholder="Phone number"
                  />
                </FormLayout.Group>
              </FormLayout>
            </Drawer.Section>

            <Drawer.Section>
              <Tabs
                variant={"underline"}
                tabs={[
                  { id: "Memberships", content: "Memberships" },
                  {
                    id: "Notes",
                    content: (
                      <span className="flex items-center gap-2">
                        Notes
                        {noteState?.notes?.length > 0 && (
                          <Badge size="small" type="gray">
                            {noteState.notes.length}
                          </Badge>
                        )}
                      </span>
                    ),
                  },
                ]}
                selected={drawerSelectedTab}
                onSelect={setDrawerSelectedTab}
              >
                <div style={{ display: drawerSelectedTab === 0 ? "block" : "none", paddingTop: "16px" }}>
                  {drawerState.customerMemberships && drawerState.customerMemberships.data.length >= 1 ? (
                    drawerState.customerMemberships.data
                      .filter((membership: any) => membership.status === "active")
                      .map((membership: any, index: number) => {
                        return (
                          <div key={index} className="mb-3">
                            <div className="flex justify-between items-start p-4 border rounded-lg">
                              <div>
                                <div className="font-semibold text-base mb-1">{membership.membership_title}</div>
                                {membership.expiry && (
                                  <div className="text-sm text-subdued">Expires: {membership.expiry}</div>
                                )}
                              </div>
                              <Badge size="small" type="success">
                                {membership.status_readable || "Active"}
                              </Badge>
                            </div>
                          </div>
                        );
                      })
                  ) : (
                    <Callout
                      type="info"
                      title={t("secure.facility.tee_sheet.tee_sheet_booking_display.047")}
                      content={t("secure.facility.tee_sheet.tee_sheet_booking_display.048")}
                    />
                  )}
                </div>

                <div style={{ display: drawerSelectedTab === 1 ? "block" : "none", paddingTop: "16px" }}>
                  <div className="flex flex-column gap-2">
                    {noteState?.notes?.length > 0 ? (
                      noteState.notes.map((note: Record<string, any>, index: number) => {
                        return (
                          <div key={index} className="note-box-drawer">
                            {note.high_priority && (
                              <div>
                                {" "}
                                <Badge
                                  iconLeft={
                                    <FontAwesomeIcon
                                      size="1x"
                                      icon={faExclamationCircle}
                                      style={{ color: "#dc2626" }}
                                    />
                                  }
                                  size="small"
                                  type="error"
                                >
                                  {t("High")}
                                </Badge>{" "}
                              </div>
                            )}

                            {/* Note content */}
                            <div className="note-content mb-2">{note.content}</div>

                            {/* Date at bottom */}
                            <div className="flex items-center gap-2 text-sm text-subdued">
                              <span>
                                {moment(note?.created_at as string).format("LLL")} • {t("Created by")}{" "}
                                {note?.author?.full_name}
                              </span>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <Callout
                        title="No notes available"
                        type="info"
                        content="There are no notes attached to this customer."
                      />
                    )}
                  </div>
                </div>
              </Tabs>
            </Drawer.Section>
          </>
        )}
      </Drawer>

      <Sheet
        size="small"
        closable
        title={t("secure.facility.tee_sheet.tee_sheet_booking_display.016")}
        cancelText={t("secure.facility.tee_sheet.tee_sheet_booking_display.017")}
        open={editCustomerState.customerEditVisible}
        okText={t("secure.facility.tee_sheet.tee_sheet_booking_display.018")}
        onOk={() => updateCustomer()}
        onCancel={() => {
          setEditCustomerState(prevState => ({
            ...prevState,
            customerEditVisible: false,
            customerMemberships: null,
          }));
        }}
        okDisabled={
          editCustomerState.customerFirstName === "" ||
          editCustomerState.customerLastName === "" ||
          (editCustomerState.customerEmail === "" && editCustomerState.customerPhone === "")
        }
      >
        <div className="customer-image-container mb-4">
          <img
            className="w-36 h-36"
            src={
              editCustomerState.customer_image !== null
                ? editCustomerState.customer_image
                : "/public/images/default_profile_image.svg"
            }
            alt={t("customer_image")}
          />

          <p>{editCustomerState.customerType || ""}</p>
          <p>{editCustomerState.cartCustomerType || ""}</p>
          <p>{editCustomerState.customerMemberNumber || ""}</p>
        </div>

        <FormLayout>
          <FormLayout.Group>
            <Input
              value={editCustomerState.customerFirstName}
              label={t("secure.facility.tee_sheet.tee_sheet_booking_display.019")}
              onChange={handleCustomerDetailsChange}
              id="customerFirstName"
            />
            <Input
              value={editCustomerState.customerLastName}
              label={t("secure.facility.tee_sheet.tee_sheet_booking_display.020")}
              onChange={handleCustomerDetailsChange}
              id="customerLastName"
            />
          </FormLayout.Group>
        </FormLayout>

        <FormLayout>
          <FormLayout.Group>
            <Input
              value={editCustomerState.customerEmail}
              label={t("secure.facility.tee_sheet.tee_sheet_booking_display.021")}
              onChange={handleCustomerDetailsChange}
              id="customerEmail"
            />
            <Input
              value={editCustomerState.customerPhone}
              label={t("secure.facility.tee_sheet.tee_sheet_booking_display.022")}
              onChange={handleCustomerDetailsChange}
              id="customerPhone"
            />
          </FormLayout.Group>
        </FormLayout>

        {/* <br /> */}

        <Tabs tabs={tabs} selected={selectedTab} onSelect={setSelectedTab}>
          <div style={{ display: selectedTab === 0 ? "block" : "none", paddingTop: "8px" }}>
            <h1 className="mb-2 ui-customer_page-header">
              {t("secure.facility.tee_sheet.tee_sheet_booking_display.046")}
            </h1>
            {editCustomerState.customerMemberships && editCustomerState.customerMemberships.data.length >= 1 ? (
              editCustomerState.customerMemberships.data
                .filter((membership: any) => membership.status === "active")
                .map((membership: any, index: number) => {
                  return (
                    <div key={index}>
                      <SimpleMembershipDisplay
                        title={membership.membership_title}
                        season={membership.season}
                        homeCourse={membership.home_facility_long_name}
                        memberNumber={membership.member_number}
                        expiry={membership.expiry}
                        status={membership.status_readable}
                        parent_membership={membership.parent_membership}
                      />
                    </div>
                  );
                })
            ) : (
              <Callout
                type="info"
                title={t("secure.facility.tee_sheet.tee_sheet_booking_display.047")}
                content={t("secure.facility.tee_sheet.tee_sheet_booking_display.048")}
              />
            )}
          </div>
          <div style={{ display: selectedTab === 1 ? "block" : "none", paddingTop: "8px" }}>
            <div className="flex flex-column gap-2">
              {selectedTab == 1 && (
                <>
                  {noteState.notes?.map((note: Record<string, any>, index: number) => {
                    return (
                      <Fragment key={index}>
                        <Note
                          key={index}
                          authorName={note.author?.full_name}
                          content={note.content}
                          dateString={moment(String(note.created_at)).format("LLL")}
                          highPriority={note.high_priority}
                        />
                      </Fragment>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </Tabs>
      </Sheet>

      <Popup
        open={noShowModal.isOpen}
        type="info"
        title={t("secure.facility.tee_sheet.tee_sheet_booking_display.049")}
        description={t("secure.facility.tee_sheet.tee_sheet_booking_display.050")}
        onOk={confirmNoShowSelection}
        okText={t("secure.facility.tee_sheet.tee_sheet_booking_display.051")}
        cancelText={t("secure.facility.tee_sheet.tee_sheet_booking_display.052")}
        onCancel={closeNoShowModal}
        okDisabled={noShowModal.type === null}
      >
        <SelectNew
          id="no-show-type-select"
          value={noShowModal.type}
          options={["charge", "defer", "weather"].map(val => ({ id: val, label: capitalize(val) }))}
          onChange={type => updateNoShowModal({ type: type })}
        />
        <br />
        <Checkbox
          label={t("secure.facility.tee_sheet.tee_sheet_booking_display.069")}
          size="large"
          checked={noShowModal.markAllPlayers}
          onChange={e => updateNoShowModal({ markAllPlayers: e.target.checked })}
        />
        <Checkbox
          label={t("No Show Email")}
          size="large"
          checked={noShowModal.sendNoShowChargeEmail}
          onChange={e => updateNoShowModal({ sendNoShowChargeEmail: e.target.checked })}
        />
      </Popup>

      <PowerCartNumbersModal
        open={props.powerCartModalVisible}
        participants={
          teeSheetStore.selectedTeeTime?.slots
            ?.filter(slot => slot.booking_participant !== null)
            ?.map(slot => ({
              participant_id: slot.booking_participant.id,
              full_name: slot.booking_participant.full_name,
              guest: slot.booking_participant.guest,
              customer_type: slot.booking_participant.customer?.customer_type,
              cart_customer_type: slot.booking_participant.customer?.cart_customer_type,
              power_cart_id: slot.booking_participant.power_cart_id,
              power_cart_number: slot.booking_participant.power_cart_number,
              seat_number: slot.booking_participant.seat_number,
            })) ?? []
        }
        onCancel={() => props.togglePowerCartModalVisible(false)}
        onSaveSuccess={props.reloadTeeTimes}
      />

      <Portal isMounted={editName.modalOpen}>
        <Sheet
          size="small"
          height="flexible"
          closable
          title={`${t("secure.facility.tee_sheet.tee_sheet_booking_display.063")} ${editName.selectedBookingParticipant?.full_name
            }`}
          open={editName.modalOpen}
          okText={t("secure.facility.tee_sheet.tee_sheet_booking_display.064")}
          onOk={handleEditName}
          okDisabled={editName?.newName?.split(" ")?.length < 2}
          onCancel={() => {
            setEditName(prevState => ({
              ...prevState,
              newName: "",
              selectedBookingParticipant: null,
              modalOpen: false,
            }));
          }}
        >
          <div className="p-2">
            <Input
              autoFocus
              label={t("secure.facility.tee_sheet.tee_sheet_booking_display.065")}
              onChange={handleEditNameChange}
              value={editName?.newName ?? ""}
              placeholder={t("secure.facility.tee_sheet.tee_sheet_booking_display.066")}
              id="newName"
            />
          </div>
        </Sheet>
      </Portal>

      <Portal isMounted={powerCartNumbersState.cartNumberModalVisible}>
        <Sheet
          size="small"
          height="flexible"
          closable
          title={t("secure.facility.tee_sheet.tee_sheet_booking_display.067")}
          cancelText={t("secure.facility.tee_sheet.tee_sheet_booking_display.057")}
          open={powerCartNumbersState.cartNumberModalVisible}
          okText={t("secure.facility.tee_sheet.tee_sheet_booking_display.068")}
          overflow
          onOk={(e: React.MouseEvent<Element, MouseEvent>) => {
            void addFeeHandler(
              powerCartNumbersState.currentSlot,
              null,
              {
                id: powerCartNumbersState.currentSlot?.booking_participant?.power_cart_variant_id,
                variantTitle: powerCartNumbersState.currentSlot?.booking_participant?.power_cart_variant_title,
                productTitle: powerCartNumbersState.currentSlot?.booking_participant?.power_cart_product_title,
              },
              e,
            );
            void saveCartNumber(powerCartNumbersState.currentSlot.booking_participant);
          }}
          onOKWhenEnterPressed
          onCancel={() => {
            setPowerCartNumbersState(prevState => ({
              ...prevState,
              cartNumberModalVisible: false,
            }));
          }}
        >
          <FormLayout>
            <FormLayout.Group>
              <div>
                <div className="text-xl text-semibold mr-1">
                  {powerCartNumbersState.currentSlot?.booking_participant?.full_name}
                </div>
                <div className="text-sm text-subdued text-semibold">
                  <span className="mr-2">
                    <span className="text-semibold">
                      {powerCartNumbersState.currentSlot?.booking_participant?.guest && (
                        <span>{t("secure.facility.tee_sheet.tee_sheet_booking_display.015")}</span>
                      )}
                    </span>
                    <span>
                      {!powerCartNumbersState.currentSlot?.booking_participant?.guest && (
                        <>
                          <span>{powerCartNumbersState.currentSlot?.booking_participant?.customer?.customer_type}</span>
                          {powerCartNumbersState.currentSlot?.booking_participant?.customer?.cart_customer_type && (
                            <span>{`(${String(
                              powerCartNumbersState.currentSlot.booking_participant.customer?.cart_customer_type,
                            )})`}</span>
                          )}
                        </>
                      )}
                    </span>
                  </span>
                </div>
              </div>
            </FormLayout.Group>
            <FormLayout.Group>
              {facilityStore.teeSheetSettings?.use_cart_inventory ? (
                <SelectNew
                  label={t("Power Cart")}
                  id={"power-cart-select"}
                  options={powerCartNumbersState?.availablePowerCarts
                    ?.filter(availableCart => {
                      return (
                        powerCartNumbersState?.selectedPowerCarts?.filter(
                          selectedCarts => selectedCarts.power_cart_id === availableCart.id,
                        ).length < MAX_SEATS_PER_CART ||
                        powerCartNumbersState?.selectedPowerCarts?.some(
                          selectedCarts =>
                            selectedCarts.power_cart_id === availableCart.id &&
                            selectedCarts.participant_id === powerCartNumbersState.currentSlot?.booking_participant.id,
                        )
                      );
                    })
                    .map(cart => ({
                      label: cart.name,
                      id: cart.id,
                    }))}
                  onChange={(value: number) =>
                    handleCartIdChange(value, powerCartNumbersState.currentSlot?.booking_participant.id)
                  }
                  value={
                    powerCartNumbersState.selectedPowerCarts?.find(
                      cart => cart.participant_id === powerCartNumbersState.currentSlot?.booking_participant.id,
                    )?.power_cart_id ?? ""
                  }
                  // disabled={powerCartNumbersState.loadedAvailableCarts === true ? false : true}
                  searchable={0.5}
                  autoFocus={powerCartNumbersState.cartNumberModalVisible}
                />
              ) : (
                <Input
                  label={t("Cart Number")}
                  value={
                    powerCartNumbersState?.selectedPowerCarts?.find(
                      cart => cart.participant_id === powerCartNumbersState.currentSlot?.booking_participant.id,
                    )?.power_cart_number ?? ""
                  }
                  type={"number"}
                  onChange={e =>
                    handleCartNumberChange(
                      Number(e.target.value),
                      powerCartNumbersState.currentSlot?.booking_participant.id,
                    )
                  }
                  autoFocus={powerCartNumbersState.cartNumberModalVisible}
                />
              )}

              <Input
                label={t("Seat Number")}
                value={
                  powerCartNumbersState?.selectedPowerCarts?.find(
                    cart => cart.participant_id === powerCartNumbersState.currentSlot?.booking_participant.id,
                  )?.seat_number ?? ""
                }
                readOnly
              />
            </FormLayout.Group>
          </FormLayout>
        </Sheet>
      </Portal>

      <Sheet
        size="small"
        height="flexible"
        closable
        title={t("Print Liability Waiver")}
        open={printLiabilityWaiverSheet.open}
        cancelText={t("Cancel")}
        okText={t("Print")}
        overflow
        onCancel={() =>
          setPrintLiabilityWaiverSheet({
            open: false,
            loading: false,
            waivers: null,
            selectedWaiverId: null,
            customerId: null,
          })
        }
        onOk={(): void => {
          const { customerId, selectedWaiverId } = printLiabilityWaiverSheet;
          if (customerId != null && selectedWaiverId != null) {
            props.loadLiabilityWaiverHandler(customerId, selectedWaiverId);
          }
        }}
        okDisabled={
          printLiabilityWaiverSheet.loading ||
          printLiabilityWaiverSheet.customerId == null ||
          !printLiabilityWaiverSheet.selectedWaiverId ||
          (Array.isArray(printLiabilityWaiverSheet.waivers) && printLiabilityWaiverSheet.waivers.length === 0)
        }
      >
        <div className="flex flex-col gap-4">
          {printLiabilityWaiverSheet.loading && !printLiabilityWaiverSheet.waivers ? (
            <div className="text-sm text-subdued">{t("Loading...")}</div>
          ) : Array.isArray(printLiabilityWaiverSheet.waivers) && printLiabilityWaiverSheet.waivers.length === 0 ? (
            <Callout
              type="info"
              title={t("No liability waivers found")}
              content={t("Create a liability waiver in Settings to print it here.")}
            />
          ) : (
            <SelectNew
              label={t("Liability Waiver")}
              id="liability-waiver-print-select"
              options={(printLiabilityWaiverSheet.waivers ?? []).map(w => ({ id: w.id, label: w.title }))}
              value={printLiabilityWaiverSheet.selectedWaiverId ?? ""}
              onChange={(value: number) =>
                setPrintLiabilityWaiverSheet(prev => ({
                  ...prev,
                  selectedWaiverId: value,
                }))
              }
              searchable={0.5}
              disabled={printLiabilityWaiverSheet.loading}
            />
          )}
        </div>
      </Sheet>

      <ReviewPlayerDetailsModal
        onClose={props.closeReviewPlayersModal}
        open={props?.reviewPlayersModalVisable}
        selectedTeeTime={teeSheetStore?.selectedTeeTime}
        customers={memoizedCustomers}
        redeemTicketStub={(stub: IStub, customerId: number, participantId: number, bookingId: number) =>
          handleQuickRedeemTicket(stub, customerId, participantId, bookingId)
        }
      />
    </>
  );
};

export default NewTeeSheetBookingDisplay;
